import { getDeepProperty } from '@/helpers/deepObject.js'
import { isIntervalInTimeframe } from './getter-helpers'
import { getTimeframeKey } from './path-helpers'

// import memoize from 'lodash/memoize'
// TODO: manually memoize factory (method-based) getters
// https://app.asana.com/0/1200062349227021/1200436725524360/f

const getters = {
  // status.fetching
  allFetching: state => getDeepProperty(state, 'status.fetching') || [],
  isFetching: state => !!getters.allFetching(state).length,

  // status.errors
  allErrors: state => getDeepProperty(state, 'status.errors') || [],
  hasErrors: state => !!getters.allErrors(state).length,

  // data.podcasts
  podcastsData: state =>
    getDeepProperty(state, 'data.podcasts') || {},
  // data.podcasts[podcastId]
  getPodcastData: state =>
    podcastId => getters.podcastsData(state)[podcastId] || {},
  // data.podcasts[podcastId].downloads
  getPodcastDownloads: state =>
    podcastId => getters.getPodcastData(state)(podcastId)['downloads'] || {},
  getPodcastDownloadsByDay: state =>
    podcastId => getters.getPodcastDownloads(state)(podcastId)['by_day'] || {},
  getPodcastDownloadsByWeek: state =>
    podcastId => getters.getPodcastDownloads(state)(podcastId)['by_week'] || {},
  getPodcastDownloadsByMonth: state =>
    podcastId => getters.getPodcastDownloads(state)(podcastId)['by_month'] || {},
  getPodcastDownloadsByInterval: state =>
    (podcastId, intervalType) =>
      ['day', 'week', 'month'].includes(intervalType)
        ? getters.getPodcastDownloads(state)(podcastId)[`by_${intervalType}`] || {}
        : {},
  getPodcastDownloadsByIntervalInTimeframe: state =>
    (podcastId, timeframe, intervalType) => {
      const allIntervals = getters
        .getPodcastDownloadsByInterval(state)(podcastId, intervalType)
      return Object
        .keys(allIntervals)
        .filter(interval => isIntervalInTimeframe(interval, timeframe))
        .reduce((intervals, interval) => ({
          ...intervals,
          [interval]: allIntervals[interval]
        }), {})
    },
  getPodcastDownloadsByDayInTimeframe: state =>
    (podcastId, timeframe) => getters.getPodcastDownloadsByIntervalInTimeframe(state)(podcastId, timeframe, 'day'),
  getPodcastDownloadsByWeekInTimeframe: state =>
    (podcastId, timeframe) => getters.getPodcastDownloadsByIntervalInTimeframe(state)(podcastId, timeframe, 'week'),
  getPodcastDownloadsByMonthInTimeframe: state =>
    (podcastId, timeframe) => getters.getPodcastDownloadsByIntervalInTimeframe(state)(podcastId, timeframe, 'month'),
  getPodcastTotalDownloadsByTimeframe: state =>
    (podcastId, timeframe) => getDeepProperty(
      getters.getPodcastDownloads(state)(podcastId),
      `totals.${getTimeframeKey(timeframe)}`
    ) || 0,
  getPodcastTotalDownloadsByTimeframeHasBeenFetched: state =>
    (podcastId, timeframe) => !!getDeepProperty(
      getters.getPodcastDownloads(state)(podcastId),
      `totals.${getTimeframeKey(timeframe)}`
    ),
  // data.episodes
  episodesData: state =>
    getDeepProperty(state, 'data.episodes') || {},
  // data.episodes[episodeId]
  getEpisodeData: state =>
    episodeId => getters.episodesData(state)[episodeId] || {},
  // data.episodes[episodeId].downloads
  getEpisodeDownloads: state =>
    episodeId => getters.getEpisodeData(state)(episodeId)['downloads'] || {},
  getEpisodeTotalDownloadsByTimeframe: state =>
    (episodeId, timeframe) => getDeepProperty(
      getters.getEpisodeDownloads(state)(episodeId),
      `totals.${getTimeframeKey(timeframe)}`
    ) || 0
}

export default getters
